<template>
  <div v-if="VUE_APP_ENV !== 'prod'" class="target-score-wrapper d-inline-block right-align-sm mt-2 mb-1 mt-sm-0 ml-2">
    <div class="target-score-box primary-color">
      <span class="target-score-text">Target Score: <b>{{ targetScore !== null && targetScore !== undefined ? targetScore : 0 }}</b></span>
      <span
        class="edit-target-btn primary-color ml-2 cursor-pointer"
        @click="openTargetModal"
        title="Edit Target Score"
      >
        <i class="fa fa-edit"></i>
      </span>
    </div>

    <!-- Edit Target Score Modal -->
    <b-modal
      v-model="showEditModal"
      title="Set Target Score"
      centered
      hide-header-close
      size="md"
    >
      <b-form @submit.prevent="editTargetScore">
        <b-form-group label="Target Score" label-for="input-target-score" class="font-weight-bold">
          <b-form-input
            id="input-target-score"
            v-model="formData.target_score"
            type="number"
            min="0"
            placeholder="Enter target score"
            required
            autofocus
            @keyup.enter="editTargetScore"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" size="sm" @click="showEditModal = false" :disabled="loading">
          Close
        </b-button>
        <b-button variant="primary" size="sm" @click="editTargetScore" :disabled="loading">
          <b-spinner small v-if="loading"></b-spinner>
          <span v-if="!loading">Set Target</span>
          <span v-else>Saving...</span>
        </b-button>
      </template>
    </b-modal>

    <!-- Toast for notification -->
    <b-toast v-model="showToast" :variant="toastVariant" title="Target Score" auto-hide-delay="3000" solid>
      <div>{{ toastMsg }}</div>
    </b-toast>
  </div>
</template>

<script>
import { TprepSessions } from "../FackApi/api/TprepSession"

export default {
  name: "TargetScoreModal",
  props: {
    propUserId: {
      type: String,
      default: null
    },
    propInterestId: {
      type: String,
      default: null
    },
    propTprepId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showEditModal: false,
      loading: false,
      targetScore: null,
      formData: {
        target_score: null
      },
      tps_id: null,
      showToast: false,
      toastMsg: "",
      toastVariant: "default",
      VUE_APP_ENV: process.env.VUE_APP_ENV
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    effectiveUserId () {
      return this.propUserId || this.$route.query.gide_user_id || this.userData?.user_id
    },
    effectiveInterestId () {
      return this.propInterestId || this.$route.params.subjId
    }
    // ,
    // effectiveTprepId () {
    //   return this.propTprepId || this.tps_id
    // }
  },
  watch: {
    effectiveUserId: {
      handler () {
        this.getTargetScore()
      }
    },
    effectiveInterestId: {
      handler () {
        this.getTargetScore()
      }
    },
    propTprepId: {
      handler (val) {
        if (val) {
          this.tps_id = val
          this.getTargetScore()
        }
      }
    }
  },
  mounted () {
    if (this.propTprepId) {
      this.tps_id = this.propTprepId
    }
    this.getTargetScore()
  },
  methods: {
    /**
     * open target score modal
     */
    openTargetModal () {
      this.formData.target_score = (this.targetScore !== null && this.targetScore !== undefined && this.targetScore !== 0) ? this.targetScore : ""
      this.showEditModal = true
    },
    /**
     * get target score
     */
    async getTargetScore () {
      try {
        const userId = this.effectiveUserId
        const interestId = this.effectiveInterestId

        if (!userId) return

        const payload = {
          user_id: userId,
          gide_user_id: userId
        }

        if (interestId) {
          payload.interest_id = interestId
        }

        // if (this.effectiveTprepId) {
        //   payload.tprep_id = this.effectiveTprepId
        // }

        const resp = await TprepSessions.tprep_sessionView(this, payload)
        if (resp && resp.resp_status && resp.resp_data) {
          const data = Array.isArray(resp.resp_data.data) ? resp.resp_data.data[0] : (resp.resp_data.data || resp.resp_data)
          if (data) {
            if (data.tprep_id) {
              this.tps_id = data.tprep_id
            }
            this.targetScore = (data.target_score !== null && data.target_score !== undefined && data.target_score !== 0) ? data.target_score : 0
            this.formData.target_score = this.targetScore ? this.targetScore : ""
          }
        }
        else {
          this.targetScore = 0
          this.formData.target_score = ""
        }
      }
      catch (err) {
        console.error("Exception in getTargetScore and err: ", err)
        this.targetScore = 0
        this.formData.target_score = ""
      }
    },
    /**
     * edit target score
     */
    async editTargetScore () {
      try {
        if (this.formData.target_score === "" || this.formData.target_score === null || isNaN(this.formData.target_score) || Number(this.formData.target_score) < 0) {
          this.toastMsg = "Please enter a valid target score."
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.loading = true
        const userId = this.effectiveUserId
        const interestId = this.effectiveInterestId
        // const tprepId = this.effectiveTprepId

        const payload = {
          user_id: userId,
          gide_user_id: userId,
          target_score: Number(this.formData.target_score),
          interest_id: interestId
        }

        // if (tprepId) {
        //   payload.tprep_id = tprepId
        // }

        const response = await TprepSessions.tprep_sessionSetTargetScore(this, payload)
        if (response && response.resp_status) {
          this.targetScore = Number(this.formData.target_score)
          this.toastMsg = "Target score updated successfully"
          this.toastVariant = "success"
          this.showToast = true
          this.showEditModal = false
          this.$emit("emitTargetScoreUpdated", this.targetScore)
        }
        else {
          this.toastMsg = response?.resp_msg || "Oops! Something went wrong. Please try again later."
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception in editTargetScore and err: ", err)
        this.toastMsg = "Oops! Something went wrong. Please try again later."
        this.toastVariant = "danger"
        this.showToast = true
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.target-score-wrapper {
  vertical-align: middle;
}
.target-score-box {
  border: 1px solid var(--iq-primary, #e5252c);
  border-radius: 5px;
  padding: 6px 14px;
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  font-size: 14px;
  line-height: 1.5;
}
.edit-target-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 1;
}
.edit-target-btn:hover {
  opacity: 0.8;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
